import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVueNext from "bootstrap-vue-next";
import VueApexCharts from "vue3-apexcharts";
import { QuillEditor } from "@vueup/vue-quill";
import Vue3Prism from "vue3-prism/lib/Vue3Prism.common.js";
import Vuelidate from "vuelidate";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import "flatpickr/dist/flatpickr.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
import "vue3-prism/lib/Vue3Prism.css";
import "./assets/custom.scss";
import TableAuditColumns from '@/components/Common/TableAuditColumns.vue';
import FormatDateTimeRow from '@/components/Common/FormatDateTimeRow.vue';
import SearchSelect from "@/components/Common/SearchSelect.vue"
import MultiSearchSelect from "@/components/Common/MultiSearchSelect.vue"
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import DateTimeInput from "@/components/Common/AppDateTimeInput.vue";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


const app = createApp(App).use(router);
app.component('TableAuditColumns', TableAuditColumns);
app.component('FormatDateTimeRow', FormatDateTimeRow);
app.component('SearchSelect', SearchSelect);
app.component('MultiSearchSelect', MultiSearchSelect);
app.component('BreadCrumb', BreadCrumb);
app.component('DateTimeInput', DateTimeInput);
app.use(VueApexCharts);
app.use(BootstrapVueNext);
app.use(Vuelidate);
app.use(VueSweetalert2);
app.component("QuillEditor", QuillEditor).use(Vue3Prism);
app.mount("#app");
